import {Bootstrap} from "./Bootstrap";

export class Menu {
	static NAV_OPEN_CLASSNAME = 'is-nav-open';
	#nav = null;
	#body = null;
	#menu = null;
	#menuBg = null;
	#scroll = 0;
	
	constructor() {
		this.init();
	}
	
	init(e) {
		this.#nav = document.querySelector('.header-btn');
		this.#body = document.body;
		this.#scroll = 0;
		let eventName = 'click';
		this.#nav.addEventListener(eventName, (e) => {
			if (this.#body.classList.contains(Menu.NAV_OPEN_CLASSNAME)) {
				this.closeMenu(e);
			} else {
				this.openMenu(e);
			}
		});
		
		
		if(Bootstrap.isTouch()){
			$('.gnav__label').click((e) => {
				let item = $(e.currentTarget).closest('.gnav__item');
				$('.gnav__item').not(item).removeClass('is-active');
				item.toggleClass('is-active');
			});
		}
		
		$('.fnav__ttl').click((e) => {
			$(e.currentTarget).closest('.fnav__group').toggleClass('is-active');
		});
		
	}
	
	// メニューを開く処理
	openMenu(e) {
		this.#scroll = window.scrollY;
		this.#body.style.top = -this.#scroll + 'px';
		this.#body.classList.add(Menu.NAV_OPEN_CLASSNAME);
	}
	
	// メニューを閉じる処理
	closeMenu(e) {
		this.#body.classList.remove(Menu.NAV_OPEN_CLASSNAME);
		this.#body.style.left = '0';
		window.scroll({
			top: this.#scroll,
			left: 0,
			behavior: 'instant'
		});
	}
}
